import { render, staticRenderFns } from "./StyledBox.vue?vue&type=template&id=b9db87de&scoped=true&lang=pug&"
import script from "./StyledBox.vue?vue&type=script&lang=js&"
export * from "./StyledBox.vue?vue&type=script&lang=js&"
import style0 from "./StyledBox.vue?vue&type=style&index=0&id=b9db87de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db87de",
  null
  
)

export default component.exports